import { Injectable } from '@angular/core';
import {
    CalculationPolicyService,
    OptionalEmailDetailCoverage,
    OptionalEmailPayload,
    PostCalculationContext
} from './calculation-policy.service';
import {NavigateManagerService} from '../navigate-manager.service';
import {RegistrationService} from './registration.service';
import {OrderPolicyService} from './order-policy.service';
import {Offer} from '../../models/offer/offer.model';
import {UrlParamsService} from './url-params.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {OfferCoveragesService} from './offer-coverages.service';
import {QueryParamName} from '../../enums/query-param-name.enum';

@Injectable({
  providedIn: 'root'
})
export class SendCalculationEmailService {

  email: string;

  get buttonVisible(): boolean {
    return this.navigateManagerService.isOffersStep || this.navigateManagerService.isOrderPolicyStep;
  }

  get buttonLabel(): string {
    if (this.navigateManagerService.isOrderPolicyStep) {
      return 'SEND-OFFER_COMPONENT.sendOffer';
    }
    return 'SEND-OFFER_COMPONENT.sendCalculation';
  }

  get isOffersStep(): boolean {
    return this.navigateManagerService.isOffersStep;
  }

  get postCalculationContext(): PostCalculationContext {
    if (this.navigateManagerService.isOffersStep) {
      return PostCalculationContext.CALCULATION_LINK_EMAIL;
    } else if (this.navigateManagerService.isOrderPolicyStep) {
      return PostCalculationContext.OFFER_LINK_EMAIL;
    }
    return null;
  }

  get selectedOfferNotModified(): Offer {
    return this.registrationService.selectedOfferService.selectedOfferNotModified;
  }

  constructor(private calculationPolicyService: CalculationPolicyService,
              private registrationService: RegistrationService,
              private orderPolicyService: OrderPolicyService,
              private urlParamsService: UrlParamsService,
              private offerCoveragesService: OfferCoveragesService,
              private navigateManagerService: NavigateManagerService) { }

  initEmail(): void {
    this.email = this.calculationPolicyService.calculationData.contact.email;
  }

  sendCalculationEmail(): Promise<void> {
    return this.calculationPolicyService.postCalculation(null, this.postCalculationContext, this.createOptionalEmailPayload());
  }

  private createOptionalEmailPayload(): OptionalEmailPayload {
    let payload: OptionalEmailPayload = {
      email: this.email
    };

    if (this.postCalculationContext === PostCalculationContext.OFFER_LINK_EMAIL) {
      payload = {
        ...payload,
        offerId: this.registrationService.registration.offerId,
        coverages: this.orderPolicyService.getOfferCoverages(),
        detailCoverages: this.getDetailCoveragesForOptionalEmail(),
        policyAmount: Offer.getOfferPrice(this.selectedOfferNotModified),
        registrationNumber: this.calculationPolicyService.calculationData.vehicle.registrationNumber,
        insuranceCompanyLogoLink: this.selectedOfferNotModified.insuranceResource.insuranceLogo.logoUri
      };

      const loggedUserId = this.urlParamsService.getQueryParam(QueryParamName.LOGGED_USER_ID);
      if (isNotNullOrUndefined(loggedUserId)) {
        payload.loggedUserId = loggedUserId;
      }
    }

    return payload;
  }

  private getDetailCoveragesForOptionalEmail(): OptionalEmailDetailCoverage[] {
    return this.offerCoveragesService.createDetailCoverageGroupBoxes(this.registrationService.selectedOfferService.selectedOffer)
        .flatMap(item => item.boxes)
        .filter(box => this.offerCoveragesService.shouldDisplayDetailBox(box))
        .map(box => ({
          label: this.offerCoveragesService.getBoxLabel(box),
          value: this.offerCoveragesService.getBoxValue(box)
        }));
  }
}
